/**
 * FleetSkipper Help Center — content index.
 *
 * 13 sections covering every module in FleetSkipper. Each section has:
 *   id        — unique string key
 *   title     — section heading
 *   summary   — one-sentence description (shown collapsed and used for search)
 *   keywords  — extra search terms beyond title/summary/step text
 *   steps     — ordered array: { text: string, image: string | null }
 *               image = filename inside /help/ (e.g. "01b-dashboard.png"), or null = text-only step.
 *
 * Images are served from /help/<filename> (public/help/).
 * All image references must match files present there.
 *
 * Plain-English tone throughout — no unexplained jargon.
 * Content is split across four chunk files (part1–part4) so each stays
 * well under the 400-line repository limit.
 */

import { gettingStarted, crew, equipment } from './part1';
import { checklists, drills, defects } from './part2';
import { incidents, riskAssessments, hoursOfRest } from './part3';
import { docsCompliance, voyages, settingUpOperations, customisingChecklists } from './part4';

const helpContent = [
  gettingStarted,
  crew,
  equipment,
  checklists,
  drills,
  defects,
  incidents,
  riskAssessments,
  hoursOfRest,
  docsCompliance,
  voyages,
  settingUpOperations,
  customisingChecklists,
];

export default helpContent;
